import { IonButton as IonicIonButton } from '@ionic/react'
import { styled } from 'styled-components'
import { myPalette } from '~/shared/ui/theme'
import { Variant } from './IconButton'

export const IonButton = styled(IonicIonButton)<{
  $variant: Variant
  $disabled?: boolean
}>`
  min-height: auto;

  opacity: ${({ $disabled }) => ($disabled ? 0.6 : 1)};

  &::part(native) {
    padding: 0;
  }

  ${({ $variant }) => {
    if ($variant === 'outline') {
      return {
        '&::part(native)': {
          padding: 0,
        },
      }
    }
    if ($variant === 'fillWhite') {
      return {
        borderRadius: '100%',
        background: myPalette.white.main,
      }
    }
    if ($variant === 'blue') {
      return {
        borderRadius: '100%',
        background: myPalette.limeGreen.main,
      }
    }
  }}
`
